import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';

export interface SearchQuery {
  query: string;
  filters: {
    [key: string]: number[];
  };
}

export interface Filter {
  type: ChatMessageEntityLinkType;
  id: number;
}

export const filtersForEntityType: Record<
  ChatMessageEntityLinkType,
  ChatMessageEntityLinkType[]
> = {
  [ChatMessageEntityLinkType.Concept]: [ChatMessageEntityLinkType.Customer],
  [ChatMessageEntityLinkType.Customer]: [],
  [ChatMessageEntityLinkType.ProductGroup]: [],
  [ChatMessageEntityLinkType.Material]: [],
  [ChatMessageEntityLinkType.Quality]: [],
  [ChatMessageEntityLinkType.DimensionGroup]: [],
  [ChatMessageEntityLinkType.Branch]: [],
};

export interface EntityItem {
  name: string;
  id: number;
  identifier: string;
  type: ChatMessageEntityLinkType;
  tag?: string;
}

type EntityCategory = 'metadata' | 'entities';

export const entityCategory: Record<ChatMessageEntityLinkType, EntityCategory> =
  {
    [ChatMessageEntityLinkType.Customer]: 'entities',
    [ChatMessageEntityLinkType.Concept]: 'entities',
    [ChatMessageEntityLinkType.ProductGroup]: 'metadata',
    [ChatMessageEntityLinkType.Material]: 'metadata',
    [ChatMessageEntityLinkType.Quality]: 'metadata',
    [ChatMessageEntityLinkType.DimensionGroup]: 'metadata',
    [ChatMessageEntityLinkType.Branch]: 'entities',
  };
